import Index from '@/layout/index';
// 发起的项目
const accounteRouter = {
    path: '/editor',
    name: 'editor',
    component: Index,
    children: [
        {
            path: 'audit',
            name: 'editorAudit',
            meta: {title: '项目审核'},
            component: () => import('@/views/editor/audit.vue')
        },
        {
            path: 'detail',
            name: 'editorDetail',
            meta: {title: '项目详情审核'},
            component: () => import('@/views/editor/detail.vue')
        },
    ],
};

export default accounteRouter;
